import { FC, forwardRef, ReactNode } from 'react';

import { Box, Tooltip } from '@mantine/core';

const Unit = forwardRef<HTMLDivElement, { onClick?: () => void; children: ReactNode }>(({ onClick, children }, ref) => (
    <Box
        data-keep-selection
        style={() => ({
            display: 'flex',
            alignItems: 'center',

            cursor: onClick ? 'pointer' : 'default',
        })}
        onClick={onClick}
        ref={ref}
    >
        {children}
    </Box>
));

Unit.displayName = 'Unit';

const UnitWithTooltip: FC<{ onClick?: () => void; children: ReactNode }> = ({ onClick, children }) => (
    <Tooltip label="Click to change unit" disabled={!onClick}>
        <Unit onClick={onClick}>{children}</Unit>
    </Tooltip>
);

export { Unit, UnitWithTooltip };
